<template>
  <div class="content">
    <div class="content-main">
      <p class="content-title">成功案例管理</p>
      <div class="content-input">
        <div class="content-input-item">
          <label>状态：</label>
          <el-select v-model="state" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in stateArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <label>展示页面：</label>
          <el-select v-model="type" placeholder="Select" style="width: 6.4em">
            <el-option v-for="item in typeArray" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="content-input-item">
          <DatePickerRange title="创建时间：" @date="getTime($event)" @check="getCheck($event)" :isChecked="isChecked"/>
        </div>
        <div class="content-input-item">
          <SearchComponents :searchTypeList="searchTypeList" :searchType="searchType" :searchValue="searchValue" @searchType="getSearchType($event)" @searchValue="getSearchValue($event)" />
        </div>
        <div class="content-input-item">
          <ElButtons type="primary" icon="search" @click="getPage(true)" :loading="searchLoading"> 查询 </ElButtons>
          <ElButtons icon="RefreshLeft" @click="refreshParam"> 重置 </ElButtons>
        </div>
      </div>
    </div>
    <div class="content-main">
      <div class="content-button">
        <div>
          <el-button type="primary" @click="editCaseDialog(-1)">添加</el-button>
        </div>
        <BtnGroup :tableRef="$refs.multipleTableRef" :colList="colList" @colListChange="colListChange($event)" @refresh="getPage"></BtnGroup>
      </div>
      <div class="content-table">
        <el-table
            ref="multipleTableRef"
            :data="pageDataList"
            style="width: 100%"
            v-loading="listLoading"
            @cell-click="toggleSelection"
            @selection-change="selsChange"
            @header-click="selsAll"
            border
        >
<!--          <el-table-column type="selection" width="55" align="center" class-name="cursor"/>-->
          <el-table-column property="createTime" label="创建时间" v-if="checkColList.indexOf('创建时间') > -1"/>
          <el-table-column property="" label="“成功案例”图片" v-if="checkColList.indexOf('“成功案例”图片') > -1" class-name="cursor">
            <template #default="scope">
              <div v-if="scope.row.caseImg">
               <el-image style="height: 60px;" :src="scope.row.caseImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="" label="“帮我约ta”图片" v-if="checkColList.indexOf('“帮我约ta”图片') > -1" class-name="cursor">
            <template #default="scope">
              <div v-if="scope.row.yuetaImg">
                <el-image style="height: 60px;" :src="scope.row.yuetaImg"><template #error><div class="el-img-error">暂无图片</div></template></el-image>
              </div>
            </template>
          </el-table-column>
          <el-table-column property="title" label="文章名称" v-if="checkColList.indexOf('文章名称') > -1" />
          <el-table-column property="msg" label="文章浏览量" v-if="checkColList.indexOf('文章浏览量') > -1">
            <template #default="scope">
              <p>{{scope.row.pageView}}/{{scope.row.pageViewShow}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="排序"  v-if="checkColList.indexOf('排序') > -1">
            <template #default="scope">
              <el-popover :visible="scope.row.show" placement="top" trigger="click" :width="200">
                <p>填写序号</p>
                <el-input v-model="scope.row.orderNum" placeholder="数字越大排越前面" style="margin: 16px 0;" @input="numChange"/>
                <div style="text-align: right; margin: 0">
                  <el-button size="small" text @click="cancleOrderNum(scope.row)">cancel</el-button>
                  <el-button size="small" type="primary" @click="changeOrderNum(scope.row)">confirm</el-button>
                </div>
                <template #reference>
                  <el-button @click="numChange(scope.row, scope.$index)" type="text" >{{ scope.row.orderNum }}</el-button>
                </template>
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column prop="" label="展示页面" v-if="checkColList.indexOf('展示页面') > -1">
            <template #default="scope">
              <p>{{scope.row.type == 0 ? '都展示' : scope.row.type == 1 ? '仅“成功案例”展示' : scope.row.type == 2 ? '仅“帮我约ta”展示' : ''}}</p>
            </template>
          </el-table-column>
          <el-table-column prop="" label="链接" v-if="checkColList.indexOf('链接') > -1">
            <template #default="scope">
              {{link+scope.row.id}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="状态" v-if="checkColList.indexOf('状态') > -1">
            <template #default="scope">
              {{scope.row.state == 0 ? '已下架' : scope.row.state == 1 ? '已上架' : ''}}
            </template>
          </el-table-column>
          <el-table-column prop="" label="操作" v-if="checkColList.indexOf('操作') > -1" width="200">
            <template #default="scope">
              <el-button size="small" @click="editCaseDialog(scope.$index,scope.row)" type="primary">编辑</el-button>
              <el-button type="success" size="small" @click="updateState(1, scope.row, scope.$index)" v-if="scope.row.state == 0" v-loading="scope.row.updateLoading">上架</el-button>
              <el-button type="danger" size="small" @click="updateState(0, scope.row, scope.$index)" v-if="scope.row.state == 1" v-loading="scope.row.updateLoading">下架</el-button>
              <el-button type="primary" size="small" class="copy-wx" :data-clipboard-text="link+scope.row.id" @click="copy">复制</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination background layout="total, prev, pager, next, jumper" :total="totalRow" :page-size="pageSize" :current-page="currentPage" @current-change="handleCurrentChange">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import DatePickerRange from '../../components/DatePickerRange'
import SearchComponents from '../../components/SearchComponents'
import BtnGroup from '../../components/BtnGroup'
import ImgViewer from '../../assets/js/imageViewer'
import {
  getSuccessfulCasePageList, updateSuccessfulCaseState, updateSuccessfulCaseOrderNum
} from '../../api/url'
import { getFormData, postJson, postFormData } from '../../api/api'
import Dialog from "@/assets/js/UEditorDialog";
import UserLogDialog from "@/components/UserLog/UserLogDialog";
import UserLog from "@/components/UserLog/UserLog";
import editCaseDialog from "./components/editCaseDialog";
import SuccessImgUpload from "@/views/success/components/SuccessImgUpload";
import Clipboard from "clipboard";

export default {
  name: "LoveLetter",
  components: { DatePickerRange, SearchComponents, BtnGroup, UserLog },
  data() {
    return {

      //状态选项
      stateArray: [
        {label: '不限', value: -1},
        {label: '已上架', value: 1},
        {label: '已下架', value: 0}
      ],
      state: 1,

      //展示页面
      typeArray: [
        {label: '不限', value: -1},
        {label: '仅成功案例展示', value: 1},
        {label: '仅帮我约ta展示', value: 2},
        {label: '都展示', value: 0}
      ],
      type: -1,

      //时间
      startTime: '',
      endTime: '',
      isChecked: true,

      //搜索
      searchTypeList: [
        {label: '文章名称', value: 1},
      ],
      searchType: 1,
      searchValue: '',

      //链接
      link: 'http://h5.yiban1314.com/case-details?caseId=',

      //刷新组
      colList: ['创建时间', '“成功案例”图片', '“帮我约ta”图片', '文章名称', '文章浏览量', '排序', '展示页面', '操作', '链接', '状态', '操作'],
      checkColList: [],

      pageDataList: [],
      currentPage: 1,
      totalRow: 0,
      pageSize: 20,

      listLoading: false,
      searchLoading: false,
      bitchPassLoading: false,
      bitchRejectLoading: false,
      bitchHideLoading: false,
      bitchForbidLoading: false,


      idArray: [],

    }
  },
  methods: {

    //分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getPage();
    },

    getTime(val) {
      this.startTime = val[0];
      this.endTime = val[1];
      // console.log(val)
    },

    getCheck(val) {
      this.isChecked = val
    },


    getSearchType(e) {
      this.searchType = e;
      // console.log(e)
    },
    getSearchValue(e) {
      this.searchValue = e;
      // console.log(e)
    },
    // 展示表格的列
    colListChange(val) {
      this.checkColList = val;
    },
    // 重置参数
    refreshParam() {
      this.isChecked = true;
      this.state = 1;
      this.type = -1;
      this.searchValue = '';
      setTimeout(()=> {
        this.getPage(true);
      }, 500)
    },

    //获取选中id
    selsChange(sels) {
      this.idArray = sels.map(item => item.msgId);
    },

    //全选
    selsAll(column, event) {
      if(column.type == 'selection') {
        let array = this.idArray;
        if(array.length == this.pageDataList.length) {
          array = [];
        }
        this.pageDataList.forEach(item => {
          if(array.indexOf(item.msgId) === -1) {
            this.$refs.multipleTableRef.toggleRowSelection(item);
          }
        })
      }
    },

    getPage(reset) {
      if(isNaN(this.currentPage)) {
        this.$message({
          showClose: true,
          duration: 1000,
          message: '请提交正确的页码',
          type: 'warning'
        })
      } else {
        if(reset) {
          this.currentPage = 1;
        }
        this.searchLoading = true;
        this.listLoading = true;
        this.sendPageReq(this.getPageParam(this.currentPage));
      }
    },

    //页面参数
    getPageParam(page) {
      let param = {};
      param['pageNum'] = page;
      param['state'] = this.state;
      param['type'] = this.type;
      param['startTime'] = this.startTime;
      param['endTime'] = this.endTime;
      param['searchValue'] = this.searchValue;
      this.pageParam = param;
      return param;
    },
    // 发送页面列表请求
    sendPageReq(param) {
      getFormData(getSuccessfulCasePageList, param).then((data) => {
        let {msg, code } = data;
        if(code == 200) {
          let result = data['data'];
          this.pageDataList = result['records'];
          this.totalRow = result['total'];
          this.pageSize = result['size'];
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.searchLoading = false;
        this.listLoading = false;
      })
          .catch((response) => {
            this.searchLoading = false;
            this.listLoading = false;
          })
    },

    toggleSelection(row, column, cell, event) {
      if(column.type == 'selection') {
        this.$refs.multipleTableRef.toggleRowSelection(row)
      }
      //更新用户日志
      if(column.label == '用户日志') {
        Dialog.open({
          title: '用户日志',
          component: UserLogDialog,
          data: {
            id: row.userId
          },
          close: () => {
            row['userLogList'] = JSON.parse(sessionStorage.getItem('userLog'));
          }
        })
      }

      if(column.label == '“成功案例”图片') {
        Dialog.open({
          title: '“成功案例”图片编辑',
          component: SuccessImgUpload,
          data: {
            id: row.id,
            src: row.caseImg,
            type: 1,
            width: '400px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

      if(column.label == '“帮我约ta”图片') {
        Dialog.open({
          title: '“帮我约ta”图片编辑',
          component: SuccessImgUpload,
          data: {
            id: row.id,
            src: row.yuetaImg,
            type: 2,
            width: '400px'
          },
          confirm: () => {
            this.getPage()
          }
        })
      }

    },


    updateState(state, row, idx) {
      this.$confirm('确认'+ (state == 1?'上架':'下架') +'文章【' + row.title + '】？').then(()=>{
        row.updateLoading = true
        let _this = this;
        let param = {};
        param['id'] = row.id
        param['state'] = state
        postFormData(updateSuccessfulCaseState, param).then((data) => {
          let {code, msg} = data;
          if(code == 200) {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'success'
            });
            row.state = state
          }else {
            _this.$message({
              showClose: true,
              duration: 1000,
              message: msg,
              type: 'warning'
            });
          }
          row.updateLoading = false;
        })
            .catch(()=>{
              row.updateLoading = false;
            })
      })
    },


    editCaseDialog(idx, row) {
      let _title = '';
      let caseForm = {}
      if (idx > -1) {
        _title = '编辑文章'
        caseForm = Object.assign({}, row);
      }else {
        _title = '添加文章'
      }
      Dialog.open({
        title: _title,
        component: editCaseDialog,
        data: {
          caseForm: caseForm,
          ids: idx,
          width: '600px'
        },
        confirm: (result) => {
          this.getPage()
        }
      })
    },

    changeOrderNum(row) {
      let _this = this;
      let param = {};
      param['id'] = row.id
      param['orderNum'] = row.orderNum
      postFormData(updateSuccessfulCaseOrderNum, param).then((data) => {
        let {code, msg} = data;
        if(code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          row.show = false
        }else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          });
        }
      })
          .catch(()=>{
          })
    },

    cancleOrderNum(row) {
      row.show = false
      row.orderNum = row.oldNum
    },

    numChange(row, idx) {
      row.oldNum = row.orderNum
      row.show = true
      this.pageDataList.map((item,index) => {
        if(index != idx && item.show == true) {
          item.show = false
          item.orderNum = item.oldNum
        }
      })
    },


    copy() {
      let clipboard = new Clipboard('.copy-wx')
      clipboard.on('success',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制成功',
          type: 'success'
        })
        clipboard.destroy() //使用destroy可以清楚缓存
      })
      clipboard.on('error',e =>{
        this.$message({
          showClose: true,
          duration: 1000,
          message: '复制失败',
          type: 'success'
        })
        clipboard.destroy()
      })
    },


  },
  mounted() {
    this.$nextTick(function() {
      this.checkColList = this.colList;
    })
    this.getPage();
  }
}
</script>

<style scoped>

</style>
